// NOT FOUND PAGE

import React from 'react'

function NotFound() {
  return (
    <div>
      This is the 404 page.
    </div>
  )
}

export default NotFound
